import {Component, Inject, OnInit} from '@angular/core';
import {AuthenticationService} from "../../../services/authentication.service";

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent implements OnInit {
  user = {};
  constructor(@Inject('AuthenticationService') private readonly authenticationService: AuthenticationService,) { }

  ngOnInit() {
    this.user = this.authenticationService.getUserDetails();
  }

}
